import { Badge } from "@mantine/core";

const COLORS: Record<string, string> = {
  active: "green",
  paid: "green",
  enabled: "green",
  closed: "blue",
  pending: "yellow",
  scheduled: "yellow",
  inactive: "gray",
  void: "gray",
  cancelled: "gray",
  canceled: "gray",
  expired: "gray",
  suspended: "orange",
  blocked: "red",
  failed: "red",
  dead_letter: "red",
};

/** Status as a coloured pill; colour by (case-insensitive) value, gray when unknown. */
export function StatusPill({ status, color }: { status: string | null | undefined; color?: string }) {
  if (!status) return null;
  return (
    <Badge variant="light" color={color ?? COLORS[status.toLowerCase()] ?? "gray"} radius="sm">
      {status.toLowerCase()}
    </Badge>
  );
}
